"use client";
import { useContext, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperType } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FinishingDataProps, FinishingListProps } from "@/app/types/types";
import FinishingComponentContent from "./FinishingComponentContent";
import { screenSizeContext } from "@/app/store/context/screenSizesContext";
import Header from "../shared/Header";
import FinishingLayer from "../shared/icons/FinishingLayer";
import FinishingTabs from "./FinishingTabs";

const FinishingComponent = ({
	list,
	data,
	optimizedImage,
}: {
	list: FinishingListProps[];
	data: FinishingDataProps;
	optimizedImage?: boolean;
}) => {
	const [activeTab, setActiveTab] = useState<number>(list?.[0]?.id);
	const [activeTabData, setActiveTabData] = useState<FinishingListProps>();
	const [swiperInstance, setSwiperInstance] = useState<SwiperType | null>(null);

	const handleTabClick = (id: number) => {
		setActiveTab(id);
	};

	useEffect(() => {
		if (list) {
			setActiveTabData(list.find((item) => item.id === activeTab));
		}
	}, [list, activeTab]);

	useEffect(() => {
		if (!swiperInstance) return;
		swiperInstance.update();
		swiperInstance.slideTo(0, 0);
	}, [activeTabData, swiperInstance]);

	const { isIpad, isMobile } = useContext(screenSizeContext);

	return (
		<div className="FinishingComponent bg-[#F1F2F3] py-[2.75rem] px pr-0 lg:pr-[2.75rem] relative lg:mb-[6.25rem] lg:py-[6.25rem]">
			<Header
				customClass="justify-start lg:justify-center text-start  lg:text-center lg:w-[45%] mx-auto"
				isCenter
				title={data?.title?.en}
				description={
					"Comfort is a top priority in O West. O Community Care is the point of contact for every O West resident, catering to their various needs."
				}
			/>
			<div className="FinishingComponent_tabs mb-16 relative z-[2]">
				<FinishingTabs
					data={list}
					activeTab={activeTab}
					handleTabClick={handleTabClick}
				/>
			</div>
			<div className="FinishingComponentContent border-t-2 relative z-[2]">
				{isMobile || isIpad ? (
					<div className="FinishingContent_list w-full min-w-0 overflow-hidden">
						<Swiper
							key={activeTab}
							className="w-full !min-w-0"
							spaceBetween={10}
							slidesPerView={1.4}
							observer
							observeParents
							watchOverflow
							onSwiper={setSwiperInstance}
						>
							{activeTabData?.children?.map((item, index) => (
								<SwiperSlide key={item.id} className="!h-auto">
									<FinishingComponentContent
										data={activeTabData?.children}
										item={item}
										index={index}
										optimizedImage={optimizedImage}
									/>
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				) : (
					<div className="FinishingContent_list flex justify-between items-center flex-row w-[100%] px-4 lg:px-[6.5rem] ">
						{activeTabData?.children?.map((item, index) => (
							<FinishingComponentContent
								data={activeTabData?.children}
								item={item}
								key={index}
								index={index}
								optimizedImage={optimizedImage}
							/>
						))}
					</div>
				)}
			</div>
			<div className="Finishing-layer absolute overflow-hidden -bottom-[10rem] lg:bottom-[-4rem] left-0  w-full h-15 opacity-50 z-[0] flex justify-center">
				<FinishingLayer />
			</div>
		</div>
	);
};

export default FinishingComponent;